import { render, staticRenderFns } from "./UserArticleCardList.vue?vue&type=template&id=44295b5e&scoped=true&"
import script from "./UserArticleCardList.vue?vue&type=script&lang=js&"
export * from "./UserArticleCardList.vue?vue&type=script&lang=js&"
import style0 from "./UserArticleCardList.vue?vue&type=style&index=0&id=44295b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44295b5e",
  null
  
)

export default component.exports